import { createReduxSlice } from '../../../redux/ReduxSlice'
import { State } from 'app/types/redux-types'

const initialState: State<number> = {
  data: 0,
  status: 'idle',
  error: null
}

const unsavedOfferCountSlice = createReduxSlice({
  name: 'unsavedOfferCount',
  initialState,
  reducers: {
    setUnsavedOfferCount: (state, action) => {
      console.log('UNSAVED APYLOAD : : ', action.payload)
      state.data = action.payload
      state.status = 'succeeded'
    },
    reset: () => initialState
  }
})

export const { setUnsavedOfferCount, reset: resetOfferCount } = unsavedOfferCountSlice.actions
export default unsavedOfferCountSlice.reducer
